import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useActiveTheme } from '../lib/activeTheme';
import { themeUsesGamePage } from '../lib/siteThemes';
import { MODE_REAL, gamePagePath } from '../lib/gamePage';

/**
 * Oyunu kendi sayfasında açan fonksiyonu döner.
 *
 * Şema oyun sayfası kullanmıyorsa fonksiyon hiçbir şey yapmaz ve `false`
 * döner; çağıran taraf o zaman eski yolu (oyun penceresi) izler. Bu sayede
 * pencere açan her yer (katalog, raydaki kısayollar, freespin "Oyna" düğmesi,
 * çapa ödülü) tek satırla sayfaya yönlenir ve şema listesi tek yerde kalır.
 *
 * Oyunun kaydı geçiş durumunda (`state.game`) taşınır: sayfa onu hazır bulur
 * ve sunucuya ikinci kez sormaz. Adres yenilenince durum kaybolur, sayfa
 * kaydı `/games/item/:id` ucundan okur.
 */
export const useGamePage = () => {
  const navigate = useNavigate();
  const enabled = themeUsesGamePage(useActiveTheme());
  return useCallback((game, mode = MODE_REAL) => {
    if (!enabled || !game?.id) return false;
    navigate(gamePagePath(game.id, mode), { state: { game } });
    return true;
  }, [enabled, navigate]);
};

export default useGamePage;
